import { render } from "./ContactLinks.vue?vue&type=template&id=971e2912&scoped=true"
import script from "./ContactLinks.vue?vue&type=script&lang=js"
export * from "./ContactLinks.vue?vue&type=script&lang=js"

import "./ContactLinks.vue?vue&type=style&index=0&id=971e2912&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971e2912"]])

export default __exports__